import { CheckboxGroup } from 'element-ui'

const YCheckboxGroup = CheckboxGroup
YCheckboxGroup.$depends = [CheckboxGroup]
YCheckboxGroup.$name = 'y-checkbox-group'
YCheckboxGroup._name = 'CheckboxGroup 复选框 多选框组'

export default YCheckboxGroup
